<template>
  <div class="about">
    <!-- <h1>This is the Dashboard page</h1> -->

    <div class="myheaderbar">
      <h1>PREHĽAD SKUPÍN ZÁKAZNÍKOV

      <b-button @click="analyze"> ANALYZE</b-button></h1>
    </div>
  
    <div class="columns">
      
      <div class="column is-one-third">
        <div class="mydiv">Segment analysis (counts)</div>

        <!-- <RandomPieChart/> -->
        <PieChart :data="segcounts" v-model="tagcounts"></PieChart>

        <div class="mydiv">Tag analysis (counts)</div>
        <PieChart :data="tagcounts" v-model="tagvalues"></PieChart>

      </div>
      <!-- <div class="column is-one-third">
        
      

        <div class="mydiv">
          <span class="panel-icon">
            <i class="fas fa-trophy" style="color: gold;" aria-hidden="true"></i>
          </span>
          Zlati zákaznici
          <br>
          <span class="panel-icon">
            <i class="fas fa-trophy" style="color: silver;" aria-hidden="true"></i>
          </span>
          Strieborni zákaznici
          <br>
          <span class="panel-icon">
            <i class="fas fa-trophy" style="color: #ac7c42;" aria-hidden="true"></i>
          </span>
          Bronzovi zákaznici
          <br>
          <span class="panel-icon">
            <i class="fas fa-trophy" style="color: #424c53;" aria-hidden="true"></i>
          </span>
          Zemiakovi zákaznici
        </div>
      </div> -->
      <div class="column is-one-third">

        <!-- <div class="mydiv">Minuté peniaze v skupine</div> -->

        <div class="mydiv">Segment analysis (amount [€])</div>
        <BarChart :data="segvalues"></BarChart>

        <div class="mydiv">Tag analysis (amount [€])</div>
        <BarChart :data="tagvalues"></BarChart>
        <!-- <RandomBarChart/> -->
        <!-- <RandomLineChart/> -->
          
      </div>
    </div>

    
  </div>
</template>

<script>

  // import RandomLineChart from '@/components/main/dashboard/RandomLineChart.vue'
  import PieChart from '@/components/main/dashboard/PieChart.vue'
  import BarChart from '@/components/main/dashboard/BarChart.vue'
  // import RandomPieChart from '@/components/main/dashboard/RandomPieChart.vue'
  // import RandomBarChart from '@/components/main/dashboard/RandomBarChart.vue'
  // import Calendar from '@/components/main/dashboard/Calendar.vue'

  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: "dashboardview",
    components: {
      // RandomLineChart,
      PieChart,
      BarChart,
      // RandomPieChart,
      // RandomBarChart,
      // Calendar
    },
    data() {
      return  {
        tagcounts: {},
        tagvalues: {},
        segcounts: {},
        segvalues: {}
      }
    },
    mounted () {
      this.analyze()
    },
    computed: {
        ...mapGetters(['allContacts', 'getAccount'])
    },
    filter: {

    },
    methods: {
      ...mapActions([]), // 'addNewContact', 'putSelectedContact'
      analyze () {
        let ctags = this.getAccount.ctags

        let tagcounts = {}
        let tagvalues = {}
        let segcounts = {}
        let segvalues = {}

        for (var ctag of this.getAccount.ctags) {
          // console.log(ctag)
          tagcounts[ctag]=0
          tagvalues[ctag]=0
        }
        const seglabels = ["undefined", "potato", "bronze", "silver", "gold"]
        for (var i =0; i<5; i++) {
          segcounts[seglabels[i]] = 0
          segvalues[seglabels[i]] = 0
        }

        for (var contact of this.allContacts) {
          // console.log(contact.status.custtotal)
          // console.log(contact.status.custclass)
          // if (!this.segcounts[contact.status.custclass]) {
          //   this.segcounts[contact.status.custclass] = 0
          // }

          // console.log(ctags)
          // console.log(contact.status.tags)
          let tmptags = contact.status.tags.filter(tag => ctags.includes(tag))
          // console.log(tmptags)
          for (var tag of tmptags) {
            tagcounts[tag] = tagcounts[tag] + 1
            tagvalues[tag] = tagvalues[tag] + contact.status.custtotal
          }
          let custclasslabel
          if (contact.status.custclass) {
            custclasslabel = seglabels[contact.status.custclass]
          } else {
            custclasslabel = "undefined"
          }
          // console.log(seglabels)
          // console.log(contact.status.custclass + "  " + custclasslabel)

          segcounts[custclasslabel] = segcounts[custclasslabel] + 1
          segvalues[custclasslabel] = segvalues[custclasslabel] + contact.status.custtotal 
        }

        this.segcounts = segcounts
        this.segvalues = segvalues
        this.tagcounts = tagcounts
        this.tagvalues = tagvalues

        // console.log(this.tagcounts)
        // console.log(this.segcounts)
        // console.log(this.tagvalues)
        // console.log(this.segvalues)
        // console.log( Object.values(this.tagcounts) )
        // console.log( Object.keys(this.tagcounts) )
      }
    },
    watch: {
      tagcounts () {
        console.log("watch DashboardView => tagcounts changed")
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .is-one-fifth {
        background: #118575;
    }
    
    .mydiv {
      margin-top: 2em;
      margin-left: 1em;
      text-align: left
    }

    .myheaderbar {
      height: 3em;
      line-height: 3em;
      background: lightgray;
      text-align: left;
      padding-left: 1em;
    }
</style>
